import { render, staticRenderFns } from "./data-filter.vue?vue&type=template&id=ab363c5c&scoped=true"
import script from "./data-filter.vue?vue&type=script&lang=ts"
export * from "./data-filter.vue?vue&type=script&lang=ts"
import style0 from "./data-filter.vue?vue&type=style&index=0&id=ab363c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab363c5c",
  null
  
)

export default component.exports